import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { overviewFieldLabelTypography } from './overviewFieldStyles';

/**
 * Styling for the independently-editable structured fields (Address / Website URL / ShareFile):
 * the value + inline "Edit"/"Add" affordances, the inline edit row, and the address dialog. All
 * tokens come from `THEME`; the literal 15px matches the field value size in `overviewFieldStyles`.
 */
export const accountStructuredFieldsStyles = StyleSheet.create({
	value: {
		color: THEME.colors.text.main,
		fontSize: 15,
		lineHeight: 1.3,
	},
	muted: {
		color: THEME.colors.text.light,
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
	// The empty-state "Add …" affordance, sized like a field value.
	addLink: {
		alignSelf: 'flex-start',
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: 15,
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		':hover': { color: THEME.colors.hover.main },
	},
	// The small inline "Edit" / "Save" affordance next to a value.
	smallLink: {
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.xs,
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		':hover': { color: THEME.colors.hover.main },
	},
	editRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
	},
	input: {
		flex: 1,
	},
	cancelButton: {
		color: THEME.colors.text.light,
		height: 'auto',
		padding: THEME.spacing.xs,
	},
	popup: {
		maxWidth: 520,
		width: '100%',
		left: '50%',
		top: '50%',
		translate: '-50% -50%',
	},
	dialogBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
	addressField: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	addressLabel: {
		...overviewFieldLabelTypography,
	},
});
